import LegalDoc from "@/components/LegalDoc";
import { PRIVACIDAD } from "@/data/privacidad";

export default function Privacidad() {
  return <LegalDoc doc={PRIVACIDAD} testId="privacidad-page" />;
}
